module.exports = __webpack_public_path__ + "img/logPwd.47fb16e8.png";